import { getData, postData } from "../api/api";

export type StepStatus = "PENDING" | "RUNNING" | "SUCCESS" | "FAILED" | "SKIPPED";
export type RunStatus = "RUNNING" | "SUCCESS" | "FAILED";
export type DeployTarget = "BE" | "UI" | "MCP";

export const DEPLOY_TARGETS: DeployTarget[] = ["BE", "UI", "MCP"];

export type PipelineStage = {
  name: string;
  status: string;
};

export type DeploymentStep = {
  key: string;
  label: string;
  status: StepStatus;
  startedAt?: string;
  finishedAt?: string;
  detail?: string;
  error?: string;
  stages?: PipelineStage[];
};

export type JenkinsBuild = {
  id?: string;
  job: string;
  displayName: string;
  number?: number;
  result?: string;
  url?: string;
  version?: string;
};

export type GitCommit = {
  sha?: string;
  message?: string;
  author?: string;
  url?: string;
};

export type DeploymentRun = {
  id: string;
  status: RunStatus;
  triggeredBy?: string;
  createdAt: string;
  finishedAt?: string;
  sourceBranch?: string;
  targetBranch?: string;
  sourceSha?: string;
  mergeSha?: string;
  error?: string;
  releaseNoteId?: string;
  targets?: DeployTarget[];
  steps: DeploymentStep[];
  jenkinsBuilds?: JenkinsBuild[];
  commits?: GitCommit[];
};

export type ReleasedImage = {
  name: string;
  tag: string;
};

export type ReleaseNote = {
  id: string;
  version: string;
  title: string;
  body: string;
  publishedAt: string;
  publishedBy?: string;
  gitSha?: string;
  commits?: GitCommit[];
  images?: ReleasedImage[];
};

export type PullRequestAction = "MERGE" | "CLOSE" | "REJECT" | "DELETE";

export type OpenPullRequest = {
  number: number;
  title: string;
  url?: string;
  author?: string;
  headBranch?: string;
  baseBranch?: string;
  headSha?: string;
  draft: boolean;
  mergeable?: boolean | null;
  mergeableState?: string;
  fromFork: boolean;
  protectedHeadBranch: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type PullRequestActionResult = {
  number: number;
  action: PullRequestAction;
  success: boolean;
  sha?: string;
  message?: string;
  error?: string;
};

export const productionDeploymentService = {
  listRuns: () => getData<DeploymentRun[]>("/admin/production-deployments"),
  getRun: (id: string) => getData<DeploymentRun>(`/admin/production-deployments/${encodeURIComponent(id)}`),
  trigger: (targets: DeployTarget[]) => postData<DeploymentRun>("/admin/production-deployments", { targets }),
  listOpenPullRequests: () => getData<OpenPullRequest[]>("/admin/production-deployments/open-pull-requests"),
  applyPullRequestActions: (body: { numbers: number[]; action: PullRequestAction; reason?: string }) =>
    postData<PullRequestActionResult[]>("/admin/production-deployments/open-pull-requests/actions", body),
};

export const releaseNoteService = {
  list: () => getData<ReleaseNote[]>("/release-notes"),
};
